import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChevronDown = () => {
  return (
    <g>
      <path d="M13.709 4.23a.75.75 0 0 1 1.151.956l-.07.085-6.25 6.499a.75.75 0 0 1-.995.076l-.085-.076L1.212 5.27a.751.751 0 0 1 .999-1.115l.082.074L8 10.166l5.709-5.936z" />
    </g>
  );
};

export default withIcon(IconChevronDown);
